export default __webpack_public_path__ + "static/media/landlord-women.bad821d6.svg";